module.exports = "<h3>{{form.name}}</h3>\n<hr>\n<!-- app-leads start -->\n<app-leads></app-leads>\n<!-- app-leads end -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/forms/detail/detail.component.html
// module id = ./src/app/components/forms/detail/detail.component.html
// module chunks = main